export function buildAnswersPayload(answers = {}) {
  const answersPayload = [];

  Object.entries(answers).forEach(([questionId, value]) => {
    const qId = Number(questionId);

    if (Array.isArray(value)) {
      value.forEach((optionId) => {
        answersPayload.push({ questionId: qId, optionId: Number(optionId) });
      });
      return;
    }

    if (typeof value === "number") {
      answersPayload.push({ questionId: qId, optionId: value });
      return;
    }

    answersPayload.push({ questionId: qId, answerText: value ?? "" });
  });

  return answersPayload;
}

export function extractAnswersFromSections(sections = []) {
  const answers = {};

  function processQuestions(questions) {
    for (const question of questions) {
      if (question.answerText != null) {
        answers[question.questionId] = question.answerText;
      }

      if (question.selectedOption) {
        answers[question.questionId] = question.selectedOption.optionId;

        if (question.selectedOption.followUpQuestion) {
          processQuestions([question.selectedOption.followUpQuestion]);
        }
      }

      if (question.selectedOptions && question.selectedOptions.length > 0) {
        answers[question.questionId] = question.selectedOptions.map((opt) => opt.optionId);

        for (const opt of question.selectedOptions) {
          if (opt.followUpQuestion) {
            processQuestions([opt.followUpQuestion]);
          }
        }
      }
    }
  }

  function processSections(sectionList) {
    for (const section of sectionList) {
      processQuestions(section.questions || []);
      processSections(section.children || []);
    }
  }

  processSections(sections);
  return answers;
}
